import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { offsetTimezone } from '../../../services/utils';

const ToDoMobileColumn = ( { row } ) => {
	return (
		<div style={{
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis'
		}}>
			<span><strong>{ row.name }</strong></span>
			<br />
			<span>{ row.program }</span>
			<br />
			{
				row.dueDate === '0001-01-01T00:00:00'
					? null
					: <span>{ offsetTimezone( row.dueDate, 'date' ) }</span>
			}
			<br />
			<span>{ row.submissionStatus.name }</span>
		</div>
	);
};

ToDoMobileColumn.propTypes = { row: PropTypes.object.isRequired };

export default memo( ToDoMobileColumn );
